import DetectBrowser from '../app/auth/detectBrowser';

export default function getChannelInfo(){
    let agent = '';
    if (typeof navigator !== 'undefined' && navigator) {
        agent = navigator.userAgent;
    }
    const browserName = DetectBrowser(agent);
    const device = browserName != '' && browserName != null ? 'WEB_' + browserName.name + '_' + browserName.version : '';
    return device.replace(/\./g, '_');
}